import dayJs from 'dayjs'
import { ActivityTopic } from './ActivityTopic'
import './ActivityCard.scoped.scss'

// Check if an entitiy url is an 'internal' URL and if so, convert to the correct path.
// Internal URLs have the form "internal://:entityName/:entityId"
const entityURL = (externalUrl) => {
  let url
  try {
    url = new URL(externalUrl)
  } catch {
    return externalUrl
  }
  if (url.protocol === 'internal:') {
    const [entityName, entityId, ...rest] = (url.hostname ? url.hostname + url.pathname : url.pathname).replace(/^[^\w]+/, '').split('/')
    switch (entityName) {
      case 'campaign':
        return `/admin/campaigns/${entityId}/overview`
      case 'flow':
        return `/admin/flows/${entityId}/overview`
      default:
        return `/admin/${entityName}/${entityId}`
    }
  } else {
    return externalUrl
  }
}

const Badge = ({ badge }) => {
  const badgeClass = badge.type === 'failed' ? 'badge badge-failed' : 'badge badge-success'

  return (
    <span className={badgeClass}>
      {badge.type === 'opened' && <SvgIconsEye className="badge-icon" />}
      {badge.type === 'clicked' && <SvgIconsClick className="badge-icon" />}
      {badge.label}
      {badge.reason && <span className="badge-reason">{badge.reason}</span>}
    </span>
  )
}

const ActivityCard = ({ activity }) => {
  const linkableEntities = activity.activityEntities.filter(
    (entity) => entity.externalUrl
  )
  let activityBody = activity.body

  linkableEntities.forEach(entity => {
    const campaignName = entity.name

    if (activityBody.includes(campaignName)) {
      const replacementText = `<a href="${entityURL(entity.externalUrl)}" style="font-weight: 600; font-size: 14px;" >${campaignName}</a>`
      activityBody = activityBody.replace(campaignName, replacementText)
    }
  })

  const badges = activity.badges || []

  return (
    <div className="activity-log-item">
      <div className="icon small circle">
        {activity.topic === 'call' && <SvgIconsActivityLogCall />}
        {activity.topic === 'sms-blast' && <SvgIconsActivityLogSms />}
        {activity.topic === 'sms-survey' && <SvgIconsActivityLogSms />}
        {activity.topic === 'sms-conversation' && <SvgIconsActivityLogSms />}
        {activity.topic === 'email-blast' && <SvgIconsActivityLogEmail />}
        {activity.topic === 'zoom' && <SvgIconsActivityLogCall />}
        {activity.topic === 'webinar' && <SvgIconsActivityLogCall />}
        {activity.topic === 'flow' && <SvgIconsActivityLogPages />}
        {activity.topic === 'added' && <SvgIconsActivityLogImported />}
        {activity.topic === 'goal' && <SvgIconsBookmarkStar />}
      </div>

      <div className="purple-60 margin-left half" style={{ minWidth: '65px' }}>
        {dayJs(activity.createdAt).format('h:mm a')}
      </div>
      <div className="topic margin-left">
        <ActivityTopic topic={activity.topic} />
      </div>
      <div className="body">
        <p className="purple-60 smaller body-margins" dangerouslySetInnerHTML={{ __html: activityBody }} />
      </div>
      {badges.length > 0 && (
        <div className="badges">
          {badges.map((badge, index) => (
            <Badge key={index} badge={badge} />
          ))}
        </div>
      )}
    </div>
  )
}

export default ActivityCard
